import { connect } from 'react-redux';
import BasicInfoLineItem from '../../../components/event/purchase-request/basic-info-line-item/index';
import { getJwtToken } from '../../../reducers';
import {
    fetchPurchaseRequestThunk,
    purchaseRequestFiles,
    updateLineItems,
    clearLineItem,
    setPurchaseRequestEventId,
    setPurchaseRequestItemId,
    removeLineItem,
    setEventSuccessMessage,
    setEventErrorMessage,
    updateTotalAmount,
    updatePurchaseRequestItemId,
    updateTotalLine,
    updateTotalNewLine,
    handlePurchaseRequestMedia,
    setVendorsDropdown,
    updatePurchaseRequestThunk,
    createPurchaseRequestThunk,
    handleStorePurchaseRequest,
    clearPurchaseRequestData,
    setDefaultVendorPR,
    createPurchaseRequestId
} from '../../../actions';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state),
    lineItems: state.ui.lineItems,
    eventVendors: state.event.vendorsInformation,
    purchaseRequest: state.PurchaseRequest,
    eventId: state.events.id,
    eventSaveSubmit: state.events.eventSaveSubmit,
    eventApproveReject: state.events.eventApproveReject,
    prSaveSubmit: state.events.prSaveSubmit,
    vendorsDropdown: state.events.vendorDropdown,
    successMessage: state.events.successMessage
});

const mapDispatchToProps = dispatch => ({
    fetchPurchaseRequest: id => dispatch(fetchPurchaseRequestThunk(id)),
    handleFiles: id => dispatch(purchaseRequestFiles(id)),
    updateLineItem: object => dispatch(updateLineItems(object)),
    clearLineItem: object => dispatch(clearLineItem(object)),
    clearAAError: message => dispatch(setEventErrorMessage(null)),
    setEventId: object => dispatch(setPurchaseRequestEventId(object)),
    setPurchaseRequestItemId: object =>
        dispatch(setPurchaseRequestItemId(object)),
    removeLineItem: index => dispatch(removeLineItem(index)),
    setEventSuccessMessage: message =>
        dispatch(setEventSuccessMessage(message)),
    clearMessage: message => dispatch(setEventSuccessMessage(null)),
    setAAError: message => dispatch(setEventErrorMessage(message)),
    updateTotalAmount: amount => dispatch(updateTotalAmount(amount)),
    updatePurchaseRequestItemId: (index, id) =>
        dispatch(updatePurchaseRequestItemId(index, id)),
    updateTotalLine: (index, amount) =>
        dispatch(updateTotalLine(index, amount)),
    updateTotalNewLine: amount => dispatch(updateTotalNewLine(amount)),
    uploadPurchaseRequestMedia: (prID, media) =>
        dispatch(handlePurchaseRequestMedia(prID, media)),
    setVendorsDropdown: object => dispatch(setVendorsDropdown(object)),
    updatePurchaseRequest: data => dispatch(updatePurchaseRequestThunk(data)),
    createPurchaseRequest: data => dispatch(createPurchaseRequestThunk(data)),
    storePurchaseRequest: data => dispatch(handleStorePurchaseRequest(data)),
    clearPurchaseRequest: item => dispatch(clearPurchaseRequestData(item)),
    setDefaultVendorPR: code => dispatch(setDefaultVendorPR(code)),
    createPurchaseRequestId: data => dispatch(createPurchaseRequestId(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoLineItem);



// WEBPACK FOOTER //
// ./src/containers/event/purchase-request/basic-info-line-item.js